import type ModalConversationService from '../../../modals/modal-conversation.service';
import type {
    FieldsDefinitionsDataService
} from '../../../features/record-editation/field7-and-field8-editors/fields-definitions-data.service';
import type {
    AuthorityField8EditorModalModel
} from '../../../features/record-editation/field7-and-field8-editors/authority-field8-editor-modal/authority-field8-editor-modal.component';

export class AuthorityField8ValueEditorService {
    public static serviceName = 'authorityField8ValueEditorService';


    /*@ngInject*/
    constructor(private modalConversationService: ModalConversationService, private fieldsDefinitionsDataService: FieldsDefinitionsDataService) {
    }

    public async editModelFunction(model: string): Promise<string> {
        const definitions = await this.fieldsDefinitionsDataService.getAuthorityField008Definitions();

        const modalModel: AuthorityField8EditorModalModel = {value: model, definitions};
        const modalWindowSettings = {isComponent: true};
        return this.modalConversationService.openModalWindowAndGetPayload<string>('authorityField8Editor', modalModel, modalWindowSettings);
    }
}

